// Sidebar.js
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.css";
// import images

import logo from "../../assets/images/logo.svg";
import icon1 from "../../assets/images/icon1.svg";
import icon2 from "../../assets/images/icon2.svg";
import icon3 from "../../assets/images/icon3.svg";
import icon4 from "../../assets/images/icon4.svg";
import icon5 from "../../assets/images/icon5.svg";
import logout from "../../assets/images/logout.svg";
import sun from "../../assets/images/sun.svg";
import moon from "../../assets/images/moon.svg";
import { useDispatch, useSelector } from "react-redux";
import {  SelectedAccount, SelectedAsset, cancelAsset, userlogout} from "../../redux/userSlice";
import { lightTheme,darkTheme, themeMode } from "../../redux/themeSlice";

const Sidebar = () => {

  const thememode=useSelector(themeMode);

  const asset=useSelector(SelectedAsset);
  
  const account=useSelector(SelectedAccount);

  

  const naviagtion=useNavigate();
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const dispatch = useDispatch();

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    dispatch(userlogout());
    naviagtion('/')
  };

  const handleCancelAsset=()=>{
    dispatch(cancelAsset());
  }

  return (
   

    // 23-05
    <div className="fullsidebox">
      <div className="collapse navbar-collapse" id="navbarNav">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="bar-top"></span>
          <span className="bar-middle"></span>
          <span className="bar-bottom"></span>
        </button>
        <div className="sidebar">
          <div className="logoimage">
            <img src={logo} />
          </div>

          <ul className="sidebar_menu">
            <li className={`${isActive("/dashboard") ? "active" : ""}`} onClick={()=>handleCancelAsset()}>
              <Link to="/dashboard">
                <img src={icon1} alt="dashboard-icon" />
                Dashboard
              </Link>
            </li>
            {/* <li className={`${isActive("/moneymanagement") ? "active" : ""}`}  onClick={()=>handleCancelAsset()}>
              <Link to="/moneymanagement">
                <img src={icon2} alt="management-icon" />
                Money management
              </Link>
            </li> */}
            {/* <li  onClick={()=>handleCancelAsset()}>
              <Link to="#">
                <img src={icon3} alt="risk-icon" />
                Risk Projections
              </Link>
            </li> */}
            {/* <li className={`${isActive("/account") ? "active" : ""}`}>
              <Link to="/account">
                <img src={icon1} alt="account-icon" />
                Account 1 - CL
              </Link>
            </li> */}
            {/* {asset?
            <li className={`${isActive("/account2") ? "active" : ""}`}>
              <Link to="/account2">
                <img src={icon1} alt="account-icon" />
                {account?.accountName} - {asset?.assetName}
              </Link>
            </li>
            :''} */}
            {/* <li className={`${isActive("/test-cl") ? "active" : ""}`}>
              <Link to="/test-cl">
                <img src={icon1} alt="account-icon" />
                Test - CL
              </Link>
            </li> */}
            {/* <li className={`${isActive("/settings") ? "active" : ""}`}  onClick={()=>handleCancelAsset()}>
              <Link to="/settings">
                <img src={icon4} alt="settings-icon" />
                Settings
              </Link>
            </li> */}
            <li className={`${isActive("/profile") ? "active" : ""}`}  onClick={()=>handleCancelAsset()}>
              <Link to="/profile">
                <img src={icon5} alt="profile-icon" />
                My profile
              </Link>
            </li>
          </ul>
          {/* <Link href="#" className="kevlar_btn widfull forphone">
            kevlar
          </Link>
          <Link href="#" className="guide_btn widfull forphone">
            reference guide
          </Link> */}
          <div className="logoutsect">
            <div className="loglink" onClick={handleLogout} style={{cursor:'pointer'}}>
              <img src={logout} alt="logout-icon" />
              Log Out
            </div>
            <div className="lightdarkbox">
              <Link
                to="#"
                className={`lightdark ${thememode ? "active" : ""}`
                  
                }
                onClick={() => dispatch(lightTheme())}
              >
                <img src={sun} alt="sun" />
                Light
              </Link>
              <Link
                to="#"
                className={`lightdark
                  ${!thememode ? "active" : ""}`
                }
                onClick={() =>  dispatch(darkTheme())}
              >
                <img src={moon} alt="moon" />
                Dark
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
